// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Ru-z","breadcrumbForward":"Su-z","breadcrumbBack":"Tu-z","selected":"Uu-z"};